<template>
  <div class="bg-white h-100 col-12">
    <ValidationObserver ref="observer" novalidate>
      <div class="col-12 pb-0">
        <SectionTitle
          bg-icon="green"
          icon="fas fa-file-plus"
          content="Añadir Documento"
          container-class="tag-badge-main-info mt-4 mb-2"
        />
        <div class="gray-box col-12 d-flex my-4 pb-4 align-items-start">
          <div class="col-3 pt-0">
            <ValidationProvider
              v-slot="{ errors }"
              class="w-100 text-left"
              name="documentTypeDropdown"
              rules="required"
            >
              <label for class="d-block bold text-left">Documento:</label>
              <CustomDropDown
                id="documentTypeDropdown"
                v-model="selectedDocumentType"
                :error="errors[0]"
                custom-error-msg="Favor de seleccionar el tipo de documento."
                placeholder="Seleccione"
                fieldkey="id"
                fieldname="name"
                required
                :options="documentTypes"
                :clearable="false"
              />
            </ValidationProvider>
          </div>
          <div class="col-6">
            <ValidationProvider
              v-slot="{ errors }"
              class="w-100 text-left"
              name="Archivo"
              rules="required"
            >
              <label for class="d-block bold text-left">Archivo:</label>
              <CustomFileInput
                ref="fileUpload3"
                v-model="document.attachment"
                :attachment-id="document.Id"
                :accept="allowedFiles"
                :value="document.attachment"
                required
                :error="errors[0]"
                :name="document.name"
                custom-error-msg="Favor de anejar el documento."
              />
            </ValidationProvider>
          </div>
          <div
            class="
                col-3
                pt-0
                buttons-container
                justify-content-end
                d-flex"
          >
            <ActionButton
              variant="outline-danger mr-2"
              i="fas fa-times-circle"
              min-width="124px"
              @click="cancel"
            >
              Cancelar
            </ActionButton>
            <ActionButton variant="success" min-width="124px" @click="save">
              Guardar
            </ActionButton>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<style scoped src="@/assets/css/component/panel-simple.css"></style>

<script>
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomFileInput from '@/components/common/CustomFileInput';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import ActionButton from '@/components/common/ActionButton';
import alert from '@/mixin/alert.mixin';
import objectToFormData from 'object-to-formdata';
import loading from '@/mixin/loading.mixin';
import { SectionTitle } from '@/components/pei/shared';

export default {
  name: 'AttachDocument',
  components: {
    CustomDropDown,
    CustomFileInput,
    ValidationObserver,
    ValidationProvider,
    ActionButton,
    SectionTitle,
  },
  mixins: [alert, loading],
  props: {
    studentSie: {
      type: Number,
      required: true,
    },
    referralStatus: {
      type: Number,
      required: true,
    },
    studentReferralId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      document: {
        Id: null,
        documentTypeId: 0,
        attachment: null,
        name: '',
        date: new Date(),
        comment: 'documento para denegado',
      },
      allowedFiles: '.pdf',
      documentTypes: [],
      selectedDocumentType: null,
      showReaseonDropDown: true,
      documentTypeCode: 'EduEspStudentEvaluationDocumentType',
      errorMsgs: {
        type: 'Favor seleccione.',
        comment: 'Campo Requerido.',
      },
    };
  },
  async mounted() {
    await this.loadDocumentTypes();
  },
  methods: {
    async loadDocumentTypes() {
      await this.$ApiGet(
        'api/documents/documenttypes?codetype=' + this.documentTypeCode
      )
        .then((res) => {
          this.documentTypes = res.data ? res.data : [];
        })
        .catch((err) => {
          this.ShowToast('', err.message, 'error');
        });
    },
    cancel() {
      this.$emit('cancel');
    },
    getDataAsJson() {
      const data = {
        id: this.studentSie,
        ItemAttachmentId: this.document.Id,
        documentTypeId: this.selectedDocumentType.id,
        file: this.document.attachment,
        comment: this.document.comment,
        date: this.document.date,
      };

      return objectToFormData(data, { indices: true });
    },
    async save() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        this.ShowToast(
          'Error',
          'Favor verificar y completar la información solicitada.',
          'error'
        );
        return;
      }
      const data = this.getDataAsJson();

      let fileExtension = this.document.attachment.name
        .toLowerCase()
        .split('.')
        .pop();

      if (fileExtension != 'pdf') {
        this.ShowToast(
          'Alerta',
          'El documento debe ser en formato PDF.',
          'error'
        );
        return;
      }

      if (this.document.attachment.size > 10485760) {
        /// 10 mb
        this.ShowToast(
          'Error',
          'El documento no puede tener un tamaño mayor a 10 Mb',
          'error'
        );
        return;
      }
      this.$ApiPost(
        `api/studentevaluation/uploadDocumentForDenegateRequest`,
        data
      )
        .then(() => {
          //update status
          this.$ApiPost(`api/studentevaluation/saveReferralStatusReason`, {
            Id: null,
            Comment: null,
            ReferralStatusId: this.referralStatus,
            StudentReferralId: this.studentReferralId,
          }).then(() => {
            this.$emit(
              'changestatus',
              this.studentReferralId,
              this.referralStatus
            );
            this.ShowToast(
              'Completado',
              'El documento ha sido cargado exitosamente.',
              'success'
            );
            this.cancel();
          });
        })

        .catch((err) => {
          if (err && err.response && err.response.data)
            this.ShowToast(err.response.data.message, '', 'error');
          else this.ShowToast(err.message, '', 'error');
        });
    },
  },
};
</script>

<style src="@/assets/css/component/badge.css"></style>
<style src="@/assets/css/component/textarea.css"></style>

<style scoped>
:root {
  --bg-eva-color: #f5eee9;
}
.color-container {
  background-color: white;
  border-radius: 5px;
  opacity: 1;
}
#modal-btn-cancelar {
  background-color: var(--bg-eva-color);
}
#modal-btn-cancelar.outline-danger:hover {
  background-color: #c9545e;
  color: white;
}
.panel-row-without-selector {
  background: var(--bg-eva-color) !important;
}

.gray-box {
  border-radius: 5px;
}
.buttons-container {
  margin-top: 29px;
}
.message {
  font-size: 16px;
}
.big-icon {
  font-size: 3em;
}
.btn-dropdown-actions i.fa-angle-down {
  font-size: 12px;
  font-weight: 400;
}
.btn-dropdown-actions::after {
  border: none;
}
.dropdown-item {
  cursor: pointer;
  padding: 0.25rem 1rem;
  font-size: 15px;
}
.dropdown-item span {
  margin-left: 10px;
}
.dropdown-item em {
  min-width: 23px;
}
.list-enter,
.list-leave-to {
  display: none;
  height: 0;
}

.list-enter-active,
.list-leave-active {
  transition: height 0.35s ease;
}
</style>
